










import Vue, { PropOptions } from 'vue';
export default Vue.extend({
  name: 'HMPopoverMenuItem',
});
